module.exports = __webpack_public_path__ + "static/media/backgroud.5a512f70.jpg";